export default __webpack_public_path__ + "static/media/logg.be28f9ce.svg";